import React from "react";
import HistoryDataSidebar, {
  HistoryDataSidebarSummaryItem,
} from "components/shared/history-data-sidebar";
import { useVendorHistory } from "../hooks/useVendorHistory";
import { useAppTranslation } from "locale/useAppTranslation";
import { TransportResourceGetVendorDetailRes } from "_services/modules/transport-resource/vendor";
import { historyDateTimeFormatter } from "_helper/timeFormatter";
import { displayUserName } from "_helper/actor";

interface VendorHistorySidebarProps {
  open: boolean;
  onClose: () => void;
  vendorId?: string;
  detail?: TransportResourceGetVendorDetailRes;
}

const VendorHistorySidebar: React.FC<VendorHistorySidebarProps> = ({
  open,
  onClose,
  vendorId,
  detail,
}) => {
  const { t: tHistory } = useAppTranslation("historyDataSidebar");

  const {
    items,
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
    searchValue,
    setSearchValue,
    fromDateValue,
    toDateValue,
    onDateChange,
  } = useVendorHistory({ vendorId, isOpen: open });

  const summaryItems: HistoryDataSidebarSummaryItem[] = [];

  if (detail?.created_by) {
    const creatorName = displayUserName(detail.created_by.name);
    const dateStr = detail.created_by.timestamp
      ? historyDateTimeFormatter(detail.created_by.timestamp)
      : "—";
    summaryItems.push({
      id: "created-by",
      label: tHistory("created-by") || "Created by",
      value: `${creatorName}, ${dateStr}`,
    });
  }

  if (detail?.updated_by || detail?.created_by) {
    const updaterName = displayUserName(detail?.updated_by?.name || detail?.created_by?.name);
    const dateStr = (detail?.updated_by?.timestamp || detail?.created_by?.timestamp)
      ? historyDateTimeFormatter(detail?.updated_by?.timestamp || detail?.created_by?.timestamp)
      : "—";
    summaryItems.push({
      id: "updated-by",
      label: tHistory("last-update-by") || "Last Update by",
      value: `${updaterName}, ${dateStr}`,
    });
  }

  return (
    <HistoryDataSidebar
      open={open}
      onClose={onClose}
      items={items}
      summaryItems={summaryItems}
      title={tHistory("title")}
      subtitle={tHistory("subtitle")}
      emptyTitle={isLoading ? "Loading history..." : undefined}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      fromDateValue={fromDateValue}
      toDateValue={toDateValue}
      onDateChange={onDateChange}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={loadMore}
    />
  );
};

export default VendorHistorySidebar;
